import React, {Component} from 'react';
import {login} from "./helper/APIUtils";
import {ACCESS_TOKEN, KEEP_SESSION_OPEN, SERVLET_PATH, VirtualHost} from "./constants";
import {Button, Col, Input, Label, Row} from "reactstrap";
import ForgotPassword from "./components/ForgotPassword";

class Faturam24Login extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			errorMessage: '',
			errorType: "",
			username: '',
			password: '',
			processing: false,
			passwordHandle: false,
			keepSessionOpen:false,
			enableForgotSection: false,
			forgetSection:false
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.validateField = this.validateField.bind(this);
		this.onChange = this.onChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.validateForm = this.validateForm.bind(this);
		this.onChangeCheck = this.onChangeCheck.bind(this);
		this.openCloseForgotPassword = this.openCloseForgotPassword.bind(this);
	}

	onChange(e) {
		this.setState({[e.target.id]: e.target.value, errorMessage: "", errorType: ""})
	}

	validateField(e) {
		return;
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateForm() {
		if (!!this.state.username && !!this.state.password) {
			return true;
		} else {
			let userMsg = "";
			let passMsg = "";
			if (!this.state.username) {
				userMsg = "Kullanıcı adı "
			}
			if (!this.state.password) {
				passMsg = "Şifre "
			}
			if (userMsg && passMsg)
				this.setState({errorMessage: userMsg + " ve " + passMsg + " girmediniz", errorType: "warning"})
			else
				this.setState({errorMessage: userMsg + passMsg + " girmediniz", errorType: "warning"})

			return false;
		}
	}

	handleKeyPress(event) {
		if (event.key === 'Enter') {
			this.handleSubmit();
		}
	}

	handleSubmit() {
		let self = this;

		if (!this.validateForm()) return;

		const loginRequest =
			{
				'username': this.state.username,
				'password': this.state.password
			};

		self.setState({processing: true})
		login(loginRequest)
			.then(response => {
				localStorage.setItem(ACCESS_TOKEN, response.data.token.accessToken);
				localStorage.setItem(KEEP_SESSION_OPEN, self.state.keepSessionOpen.toString());
				self.setState({processing: false, errorType: ""}, () => self.props.onLogin());
			}).catch(error => {
			let response = error.response;
			let status = response.status;
			let errorMessage = "";
			if (!!status && status >= 400 && status !== 500) {
				errorMessage = response.data;
			} else {
				errorMessage = error.message ? error.message : 'Bir sorun oluştu.';
			}
			self.setState({errorMessage, processing: false, errorType: "danger"})
		});
	}

	onChangeCheck(){
		let keepSessionOpen=this.state.keepSessionOpen;
		this.setState({keepSessionOpen:!keepSessionOpen});
	}

	openCloseForgotPassword(value){
		let self = this;
		self.setState({enableForgotSection:value})
		console.log("open close");
	}

	render() {
		return (
			<Row style={{height: '100vh'}}>
				<Col sm="12" lg="6" style={{padding:0}}>
					<img className="baro-background" src={SERVLET_PATH+"/api/virtual/resource/backgroundFaturam24.png"}/>
				</Col>

				<Col sm="12" lg="6" style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
					{this.state.enableForgotSection &&
					<ForgotPassword close={this.openCloseForgotPassword}/> }

					{!this.state.enableForgotSection &&
					<div>
						<Row>
							<Col sm="12" lg="12" style={{display:"flex",flexDirection:"column",alignItems:"center",padding:"3% 3% 5%"}}>
								<img style={{maxWidth:'75%'}} src={SERVLET_PATH + "/api/virtual/resource/loginBaro.png"} alt="now-logo"/>
							</Col>
						</Row>

						<Row>
							<p className="mx-auto" style={{
								fontSize: '1.5em',
								fontFamily: 'sans-serif'}}>
								e-Arşiv 5000/30000 Portalı Girişi</p>
						</Row>

						<Row style={{padding: '2% 20% 5% 20%'}}>
							<Col xs='12' className="input-group"
								 style={{
									 borderBottom: '1px solid #8c8c8c',
									 padding: '0 0 0 0',
									 margin: '-10px 5px 20px 5px',
									 height: '60px',
									 display: 'flex',
									 flexDirection: 'row',
									 alignItems: 'flex-end'
								 }}>

								<p style={{
									fontSize: '17px',
									color: '#8c8c8c',
									padding: '5px 10px 10px 0px',
									margin: 0,
									width: '35%',
									fontFamily: 'sans-serif'
								}}>Kullanıcı Adı</p>

								<input placeholder=""
									   autoComplete="false"
									   autoFocus
									   id="username"
									   name="username"
									   onKeyPress={this.handleKeyPress}
									   onChange={this.onChange}
									   value={this.state.username}
									   type="text"
									   style={{fontSize: '18px', margin: '0 0 11px 0', width: '65%'}}/>
							</Col>

							<Col xs='12' className="input-group"
								 style={{
									 borderBottom: '1px solid #8c8c8c',
									 padding: '0 0 0 0',
									 margin: '-10px 5px 20px 5px',
									 height: '60px',
									 display: 'flex',
									 flexDirection: 'row',
									 alignItems: 'flex-end'
								 }}>

								<p style={{
									fontSize: '17px',
									color: '#8c8c8c',
									padding: '5px 10px 10px 0px',
									margin: 0,
									width: '35%',
									fontFamily: 'sans-serif'
								}}>Şifre</p>

								<input placeholder=""
									   autoComplete="false"
									   id="password"
									   name="password"
									   onKeyPress={this.handleKeyPress}
									   onChange={this.onChange}
									   value={this.state.password}
									   type="password"
									   style={{fontSize: '18px', margin: '0 0 11px 0', width: '65%'}}/>
							</Col>

							{this.state.errorMessage &&
							<Col xs='12' style={{textAlign: 'center', padding: '0', margin: '4% 0 0 0'}}>
								<label className='errorMessage'>{this.state.errorMessage}</label>
							</Col>}

							<Col sm='14' md='14' lg='14' className="no-border  input-group input-group-lg">
								<Label style={{
									marginTop: "5px",
									paddingLeft: "0.6rem",
									fontSize: "14px",
									fontWeight: "bold",
									color: "#7f858c"
								}} check>
									<Input type="checkbox"
										   id="checkbox"
										   style={{paddingLeft:"1rem",fontSize:"12px",fontWeight:"bold"}}
										   checked={this.state.keepSessionOpen}
										   onChange={(e)=>this.onChangeCheck(e)} />{'   '}
									Oturum Açık Kalsın
								</Label>
								<Label className="ml-auto forgot-password" style={{padding:0,marginTop:0}}>
									<a onClick={() => this.openCloseForgotPassword(true)}>Şifremi Unuttum</a>
								</Label>
							</Col>
						</Row>

						<Row>
							<Col xs='12' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
								<Button color="primary" style={{width: '200px', borderRadius: 0, background: '#2386c6'}}
										onClick={this.handleSubmit}>
									{!this.state.processing ? 'GİRİŞ' : <i className="fa fa-spinner fa-spin"/>}
								</Button>
							</Col>
						</Row>

					</div>
					}

				</Col>

			</Row>
		);
	}
}

export default Faturam24Login;